(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6952],{

/***/ 479:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/incentive",
      function () {
        return __webpack_require__(12332);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94589);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39112);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  // background-color: ",
        ";\n  border-radius: 16px;\n  // box-shadow: ",
        ";\n  color: ",
        ";\n  display: block;\n  font-size: 16px;\n  height: ",
        ";\n  outline: 0;\n  padding: 0 16px;\n  width: 100%;\n  // border: 1px solid ",
        ";\n  border: none;\n  font-weight: 600;\n\n  &::placeholder {\n    /* color: ",
        "; */\n    color: #999;\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ",
        ";\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function getBoxShadow(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function getHeight(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "48px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "40px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-996b64d7-0"
}).withConfig({
    componentId: "sc-de4b360c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning, isSuccess = param.isSuccess;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.focus;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 39112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ }),

/***/ 77214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94589);
/* harmony import */ var _noahswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65208);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93293);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  width: 0;\n  position: relative;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: transparent;\n  font-size: ",
        ";\n  text-align: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    /* font-size: 20px; */\n    color: #999;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-62693d3a-0"
})(_templateObject(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.text;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "16px";
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "right";
});
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function InnerInput(_param) {
    var value = _param.value, onUserInput = _param.onUserInput, placeholder = _param.placeholder, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "value",
        "onUserInput",
        "placeholder"
    ]);
    var enforcer = function(nextUserInput) {
        if (nextUserInput === "" || inputRegex.test((0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .escapeRegExp */ .hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var t = (0,_noahswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledInput, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest), {
        value: value,
        onChange: function(event) {
            // replace commas with periods, because we exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        // const now = new Date();
        // const hours = now.getHours().toString().padStart(2, '0');
        // const minutes = now.getMinutes().toString().padStart(2, '0');
        // const seconds = now.getSeconds().toString().padStart(2, '0');
        // const formattedTime = `${hours}:${minutes}:${seconds}`;
        // console.log(formattedTime + '---输入的值', event.target.value)
        },
        // universal input options
        inputMode: "decimal",
        title: t("noah98"),
        autoComplete: "off",
        autoCorrect: "off",
        // text-specific options
        type: "text",
        pattern: "^[0-9]*[.,]?[0-9]*$",
        placeholder: placeholder || "0.0",
        minLength: 1,
        maxLength: 79,
        spellCheck: "false"
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 39475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ AutoRow; },
/* harmony export */   "DA": function() { return /* binding */ RowFixed; },
/* harmony export */   "m0": function() { return /* binding */ RowBetween; }
/* harmony export */ });
/* unused harmony export RowFlat */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94589);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44850);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-wrap: wrap;\n  margin: ",
        ";\n  justify-content: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: fit-content;\n  margin: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bc277a35-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "center";
}, function(param) {
    var justify = param.justify;
    return justify !== null && justify !== void 0 ? justify : "flex-start";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "0";
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
});
var RowBetween = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-bc277a35-1"
})(_templateObject1());
var RowFlat = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc277a35-2"
})(_templateObject2());
var AutoRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-bc277a35-3"
})(_templateObject3(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var gap = param.gap;
    return gap;
});
var RowFixed = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-bc277a35-4"
})(_templateObject4(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var gap = param.gap;
    return gap;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Row);


/***/ }),

/***/ 34966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CurrencyLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94589);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64011);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79350);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledLogo = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Logo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3deedc91-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function CurrencyLogo(param) {
    var currency = param.currency, _size = param.size, size = _size === void 0 ? "24px" : _size, style = param.style;
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().chainId;
    var srcs = [];
    if ((currency === null || currency === void 0 ? void 0 : currency.symbol) === "EOS" || (currency === null || currency === void 0 ? void 0 : currency.symbol) === "WEOS") {
        // srcs = [
        //   `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/17777-0xc00592aa41d32d137dc480d9f6d0df19b860104f-eos.png`,
        // ]
        srcs = [
            "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/17777-0xc00592aa41d32d137dc480d9f6d0df19b860104f-eos.png", 
        ];
    // currency?.symbol === 'BTC' ||
    } else if ((currency === null || currency === void 0 ? void 0 : currency.symbol) === "BTC") {
        srcs = [
            "/images/small-img/btc.svg"
        ];
    } else if ((currency === null || currency === void 0 ? void 0 : currency.symbol) === "XBTC") {
        srcs = [
            "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/7200-0x4aa4365da82acd46e378a6f3c92a863f3e763d34-xbtc.png", 
        ];
    } else if ((currency === null || currency === void 0 ? void 0 : currency.address) && (currency === null || currency === void 0 ? void 0 : currency.symbol)) {
        // srcs = [
        //   `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/${chainId}-${currency?.address.toLowerCase()}-${currency?.symbol.toLowerCase()}.png`,
        // ]
        srcs = [
            "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/".concat(chainId, "-").concat(currency === null || currency === void 0 ? void 0 : currency.address.toLowerCase(), "-").concat(currency === null || currency === void 0 ? void 0 : currency.symbol.toLowerCase(), ".png"), 
        ];
    }
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLogo, {
        size: size,
        srcs: srcs,
        alt: "".concat((ref = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && ref !== void 0 ? ref : "token", " logo"),
        style: style
    });
}


/***/ }),

/***/ 79350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ BAD_SRCS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var BAD_SRCS = {};
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback triangle alert
 */ var Logo = function(_param) {
    var srcs = _param.srcs, alt = _param.alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "srcs",
        "alt"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), refresh = ref[1];
    var src = srcs.find(function(s) {
        return !BAD_SRCS[s];
    });
    if (src) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS[src] = true;
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
        src: "/images/small-img/default-icon.png",
        alt: ""
    }));
// return <HelpIcon {...rest} />
};
/* harmony default export */ __webpack_exports__["Z"] = (Logo);


/***/ }),

/***/ 98956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xw": function() { return /* reexport */ CurrencyLogo/* default */.Z; },
  "ge": function() { return /* reexport */ DoubleCurrencyLogo; },
  "_r": function() { return /* reexport */ ListLogo; }
});

// EXTERNAL MODULE: ./src/components/Logo/CurrencyLogo.tsx
var CurrencyLogo = __webpack_require__(34966);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
;// CONCATENATED MODULE: ./src/components/Logo/DoubleLogo.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4ab4b9b-0"
})(_templateObject(), function(param) {
    var margin = param.margin;
    return margin && "4px";
});
function DoubleCurrencyLogo(param) {
    var currency0 = param.currency0, currency1 = param.currency1, _size = param.size, size = _size === void 0 ? 20 : _size, _margin = param.margin, margin = _margin === void 0 ? false : _margin;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        margin: margin,
        children: [
            currency0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
                currency: currency0,
                size: "".concat(size.toString(), "px"),
                style: {
                    marginRight: "-5px"
                }
            }),
            currency1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
                currency: currency1,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/uriToHttp.ts
var uriToHttp = __webpack_require__(90570);
;// CONCATENATED MODULE: ./src/hooks/useHttpLocations.ts


function useHttpLocations(uri) {
    return (0,react.useMemo)(function() {
        return uri ? (0,uriToHttp/* default */.Z)(uri) : [];
    }, [
        uri
    ]);
}

// EXTERNAL MODULE: ./src/components/Logo/Logo.tsx
var Logo = __webpack_require__(79350);
;// CONCATENATED MODULE: ./src/components/Logo/ListLogo.tsx

function ListLogo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    ListLogo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledListLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo/* default */.Z).withConfig({
    componentId: "sc-60793395-0"
})(ListLogo_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function ListLogo(param) {
    var logoURI = param.logoURI, style = param.style, _size = param.size, size = _size === void 0 ? "24px" : _size, alt = param.alt;
    var srcs = useHttpLocations(logoURI);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListLogo, {
        alt: alt,
        size: size,
        srcs: srcs,
        style: style
    });
}

;// CONCATENATED MODULE: ./src/components/Logo/index.ts





/***/ }),

/***/ 50165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UK": function() { return /* binding */ ApprovalState; },
  "qL": function() { return /* binding */ useApproveCallback; },
  "re": function() { return /* binding */ useApproveCallbackFromTrade; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(67539);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var localization_src = __webpack_require__(65208);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var swap_sdk_src = __webpack_require__(79331);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(61905);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(91001);
;// CONCATENATED MODULE: ./src/hooks/useTokenAllowance.ts




function useTokenAllowance(token, owner, spender) {
    var contract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address, false);
    var inputs = (0,react.useMemo)(function() {
        return [
            owner,
            spender
        ];
    }, [
        owner,
        spender
    ]);
    var allowance = (0,hooks/* useSingleCallResult */.Wk)(contract, "allowance", inputs).result;
    return (0,react.useMemo)(function() {
        return token && allowance ? swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(token, allowance.toString()) : undefined;
    }, [
        token,
        allowance
    ]);
}
/* harmony default export */ var hooks_useTokenAllowance = (useTokenAllowance);

// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(42658);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
;// CONCATENATED MODULE: ./src/hooks/useApproveCallback.ts















var ApprovalState;
(function(ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
function useApproveCallback(amountToApprove, spender) {
    var ref;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var toastError = (0,useToast/* default */.Z)().toastError;
    var token = (amountToApprove === null || amountToApprove === void 0 ? void 0 : (ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isToken) ? amountToApprove.currency : undefined;
    var currentAllowance = hooks_useTokenAllowance(token, account !== null && account !== void 0 ? account : undefined, spender);
    var pendingApproval = (0,transactions_hooks/* useHasPendingApproval */.wB)(token === null || token === void 0 ? void 0 : token.address, spender);
    // check the current approval status
    var approvalState = (0,react.useMemo)(function() {
        var ref;
        if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
        if ((ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isNative) return ApprovalState.APPROVED;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove) ? pendingApproval ? ApprovalState.PENDING : ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }, [
        amountToApprove,
        currentAllowance,
        pendingApproval,
        spender
    ]);
    var tokenContract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var approve = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var useExact, estimatedGas;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (approvalState !== ApprovalState.NOT_APPROVED) {
                        // toastError(t('Error'), t('Approve was called unnecessarily'))
                        console.error("approve was called unnecessarily");
                        return [
                            2
                        ];
                    }
                    if (!token) {
                        toastError(t("Error"), t("No token"));
                        console.error("no token");
                        return [
                            2
                        ];
                    }
                    if (!tokenContract) {
                        toastError(t("Error"), t("Cannot find contract of the token %tokenAddress%", {
                            tokenAddress: token === null || token === void 0 ? void 0 : token.address
                        }));
                        console.error("tokenContract is null");
                        return [
                            2
                        ];
                    }
                    if (!amountToApprove) {
                        toastError(t("Error"), t("Missing amount to approve"));
                        console.error("missing amount to approve");
                        return [
                            2
                        ];
                    }
                    if (!spender) {
                        toastError(t("Error"), t("No spender"));
                        console.error("no spender");
                        return [
                            2
                        ];
                    }
                    useExact = false;
                    return [
                        4,
                        tokenContract.estimateGas.approve(spender, bignumbers/* MaxUint256 */.Bz).catch(function() {
                            // general fallback for tokens who restrict approval amounts
                            useExact = true;
                            return tokenContract.estimateGas.approve(spender, amountToApprove.quotient.toString());
                        })
                    ];
                case 1:
                    estimatedGas = _state.sent();
                    // eslint-disable-next-line consistent-return
                    return [
                        2,
                        callWithGasPrice(tokenContract, "approve", [
                            spender,
                            useExact ? amountToApprove.quotient.toString() : bignumbers/* MaxUint256 */.Bz
                        ], {
                            gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGas)
                        }).then(function(response) {
                            addTransaction(response, {
                                summary: "Approve ".concat(amountToApprove.currency.symbol),
                                translatableSummary: {
                                    // text: 'Approve %symbol%',
                                    text: "noah410",
                                    data: {
                                        symbol: amountToApprove.currency.symbol ? amountToApprove.currency.symbol : amountToApprove.currency.name
                                    }
                                },
                                approval: {
                                    tokenAddress: token.address,
                                    spender: spender
                                },
                                type: "approve"
                            });
                        }).catch(function(error) {
                            // logError(error)
                            console.error("Failed to approve token", error);
                            if ((error === null || error === void 0 ? void 0 : error.code) !== 4001) {
                                toastError(t("Error"), error.message || error);
                            }
                        // throw error
                        })
                    ];
            }
        });
    }), [
        approvalState,
        token,
        tokenContract,
        amountToApprove,
        spender,
        addTransaction,
        callWithGasPrice,
        t,
        toastError
    ]);
    return [
        approvalState,
        approve
    ];
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromTrade(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, chainId = arguments.length > 2 ? arguments[2] : void 0;
    var amountToApprove = (0,react.useMemo)(function() {
        return trade ? (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage)[actions/* Field.INPUT */.gN.INPUT] : undefined;
    }, [
        trade,
        allowedSlippage
    ]);
    return useApproveCallback(amountToApprove, exchange/* ROUTER_ADDRESS */.bR[chainId]);
}


/***/ }),

/***/ 71228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useCallWithGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68605);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16329);









function useCallWithGasPrice() {
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useGasPrice */ .Fh)();
    /**
   * Perform a contract call with a gas price returned from useGasPrice
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ var callWithGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, hasManualGasPriceOverride, tx, ref;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .addBreadcrumb */ .n_)({
                            type: "Transaction",
                            message: "Call with gas price: ".concat(gasPrice),
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(contract, methodName);
                        hasManualGasPriceOverride = overrides === null || overrides === void 0 ? void 0 : overrides.gasPrice;
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(methodArgs).concat([
                                hasManualGasPriceOverride ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, overrides) : (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, overrides), {
                                    gasPrice: gasPrice
                                })
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .addBreadcrumb */ .n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        gasPrice
    ]);
    return {
        callWithGasPrice: callWithGasPrice
    };
}


/***/ }),

/***/ 12332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ incentive; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(25349);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text_Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Box_Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(6260);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(67539);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(49438);
// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/NumericalInput.tsx
var NumericalInput = __webpack_require__(77214);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx + 1 modules
var CurrencyLogo = __webpack_require__(60764);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var localization_src = __webpack_require__(65208);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(62349);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(55999);
// EXTERNAL MODULE: ./src/config/abi/Bribe.json
var Bribe = __webpack_require__(33109);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/hooks/useApproveCallback.ts + 1 modules
var useApproveCallback = __webpack_require__(50165);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/wagmi.esm.js + 25 modules
var wagmi_esm = __webpack_require__(38109);
// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 1 modules
var contracts_lib_esm = __webpack_require__(64146);
// EXTERNAL MODULE: ./src/components/ResultModal/index.tsx
var ResultModal = __webpack_require__(28393);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/utils/transactionErrorToUserReadableMessage.ts
var transactionErrorToUserReadableMessage = __webpack_require__(42808);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var swap_sdk_src = __webpack_require__(79331);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./src/components/CommitButton.tsx
var CommitButton = __webpack_require__(72234);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_construct.mjs
var _construct = __webpack_require__(89101);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(9355);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(92510);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(41914);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(39475);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 3 modules
var Logo = __webpack_require__(98956);
// EXTERNAL MODULE: ./src/service/service.ts + 1 modules
var service = __webpack_require__(36141);
// EXTERNAL MODULE: ./src/service/chainUtils.ts
var chainUtils = __webpack_require__(99635);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/views/Bribery/components/CoinModal.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  padding: 12px 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  /* padding: 100px 24px 60px; */\n  justify-content: center;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 250px;\n  overflow: auto;\n  padding-right: 15px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 0;\n  height: 56px;\n  display: grid;\n  grid-template-columns: auto minmax(auto, 1fr) minmax(0, 72px);\n  grid-gap: 8px;\n  cursor: ",
        ";\n  pointer-events: ",
        ";\n  :hover {\n    background-color: ",
        ";\n  }\n  opacity: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var ModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-26e52f44-0"
})(_templateObject());
var ModalBody = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-26e52f44-1"
})(_templateObject1());
var CoinScroll = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-26e52f44-2"
})(_templateObject2());
var ListItem = (0,styled_components_browser_esm/* default */.ZP)(Row/* RowBetween */.m0).withConfig({
    componentId: "sc-26e52f44-3"
})(_templateObject3(), function(param) {
    var disabled = param.disabled;
    return !disabled && "pointer";
}, function(param) {
    var disabled = param.disabled;
    return disabled && "none";
}, function(param) {
    var theme = param.theme, disabled = param.disabled;
    return !disabled && theme.colors.background;
}, function(param) {
    var disabled = param.disabled, selected = param.selected;
    return disabled || selected ? 0.5 : 1;
});
var CoinModal = function(param) {
    var onDismiss = param.onDismiss, setCoin = param.setCoin;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var inputRef = (0,react.useRef)();
    var router = (0,next_router.useRouter)();
    // const parsedQueryChainId = Number(router.query.chainId)
    // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId')) || 17777
    // const { chainId } = useActiveWeb3React()
    var ref1 = (0,react.useState)([]), listData = ref1[0], setListData = ref1[1];
    var account = (0,src/* useWeb3React */.Ge)().account;
    var ref2 = (0,react.useState)({}), voteAddress = ref2[0], setVoteAddress = ref2[1];
    var ref3 = (0,react.useState)([]), tokenList = ref3[0], setTokenList = ref3[1];
    var debouncedQuery = (0,useDebounce/* default */.Z)(searchQuery, 200);
    // const handleEnter = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    //   if (e.key === 'Enter') {
    //   }
    // }, [])
    var tokenLists = Object.values((0,wallet_hooks/* useTokenBalances */.Z)(account !== null && account !== void 0 ? account : undefined, listData));
    // if (debouncedQuery) {
    //   if (account) {
    //     tokenLists = tokenLists.filter((v) => v?.currency?.symbol.indexOf(debouncedQuery.toUpperCase()) > -1)
    //   } else {
    //     tokenLists = listData.filter((v) => v?.currency?.symbol.indexOf(debouncedQuery.toUpperCase()) > -1)
    //   }
    // }
    if (!account) {
        tokenLists = listData.map(function(v) {
            return swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(v, 0);
        });
    }
    console.log(tokenLists, "tokenLists");
    console.log(listData, "listData");
    var fetch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, baseURL, chainid, ref1, data, code, formatData, listDatas;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
                        return [
                            4,
                            (0,service/* getGuageCoinList */.Nx)({
                                baseURL: baseURL,
                                chainid: chainid
                            })
                        ];
                    case 1:
                        ref1 = _state.sent(), data = ref1.data, code = ref1.code;
                        formatData = [];
                        if (!code) {
                            formatData = (data === null || data === void 0 ? void 0 : data.map(function(v) {
                                var vv = v;
                                var decimal = vv.decimal;
                                delete vv.decimal;
                                return {
                                    chainId: vv.chain_id,
                                    address: vv.contract,
                                    decimals: decimal,
                                    symbol: vv.symbol,
                                    name: vv.name,
                                    logoURI: "aaa"
                                };
                            })) || [];
                            listDatas = formatData.map(function(v) {
                                var value = Object.values(v);
                                // @ts-ignore
                                return (0,_construct/* default */.Z)(swap_sdk_src/* Token */.WU, (0,_to_consumable_array/* default */.Z)(value));
                            });
                            // console.log(listDatas, 'listDatas')
                            setListData(listDatas);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function fetch() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetCoin = function(item) {
        setCoin(item);
        onDismiss();
    };
    (0,react.useEffect)(function() {
        // if (!account) return
        fetch();
    }, [
        account
    ]);
    // useEffect(() => {
    //   let copyTokenLists = tokenLists
    //   if (debouncedQuery) {
    //     copyTokenLists = copyTokenLists.filter((v) => v?.currency?.symbol.indexOf(debouncedQuery.toUpperCase()) > -1)
    //   }
    //   setTokenList(copyTokenLists)
    // }, [debouncedQuery, tokenLists])
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalContainer */.F0, {
        $minWidth: isMobile ? "100%" : "418px",
        $minHeight: !isMobile ? "300px" : "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            style: {
                width: isMobile ? "100% " : "418px",
                height: !isMobile ? "auto" : "auto"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                            style: {
                                fontSize: "20px",
                                fontWeight: "500"
                            },
                            children: t("noah142")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "text",
                            onClick: onDismiss,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                width: "24px",
                                color: "#000"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                            style: {
                                width: "90%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                                style: {
                                    border: "1px solid #F6F6F6",
                                    paddingLeft: "10px",
                                    borderRadius: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/small-img/icon3.png",
                                        width: "20px",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "token-search-input",
                                        // 请输入代币或者粘贴地址
                                        placeholder: t("noah402"),
                                        scale: "lg",
                                        autoComplete: "off",
                                        value: searchQuery,
                                        type: "text",
                                        ref: inputRef,
                                        onChange: function(event) {
                                            setSearchQuery(event.target.value);
                                        },
                                        // onKeyDown={handleEnter}
                                        style: {
                                            fontWeight: 400
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            style: {
                                background: "#FAFAFA",
                                width: "90%",
                                borderRadius: "6px"
                            },
                            padding: "15px",
                            my: "16px",
                            pr: "0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                    justifyContent: "space-between",
                                    mb: "10px",
                                    pr: "15px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                            fontSize: "12px",
                                            color: "#85868A",
                                            children: t("noah191")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                            fontSize: "12px",
                                            color: "#85868A",
                                            children: t("noah312")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinScroll, {
                                    children: tokenLists.length > 0 ? tokenLists === null || tokenLists === void 0 ? void 0 : tokenLists.map(function(v, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem, {
                                            onClick: function() {
                                                handleSetCoin(v);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                                    currency: v.currency,
                                                    size: "28px",
                                                    style: {
                                                        marginRight: "6px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.ZP, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                            small: true,
                                                            bold: true,
                                                            children: v.currency.symbol
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                            color: "textSubtle",
                                                            fontSize: "12px",
                                                            ellipsis: true,
                                                            maxWidth: "200px",
                                                            children: v.currency.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                                                    style: {
                                                        justifySelf: "flex-end"
                                                    },
                                                    children: v === null || v === void 0 ? void 0 : v.toSignificant()
                                                })
                                            ]
                                        }, i);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        style: {
                                            height: "240px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/small-img/noData.png",
                                                alt: "",
                                                width: "64px",
                                                style: {
                                                    marginBottom: "10px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                color: "textSubtle",
                                                textAlign: "center",
                                                children: t("noah116")
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            small: true,
                            mb: "50px",
                            textAlign: "left",
                            style: {
                                width: "90%"
                            },
                            color: "#92929B",
                            children: t("noah351")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_CoinModal = (CoinModal);

;// CONCATENATED MODULE: ./src/views/Bribery/components/LiquidityModal.tsx
/* eslint-disable */ 


function LiquidityModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  padding: 12px 24px;\n"
    ]);
    LiquidityModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LiquidityModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  /* padding: 100px 24px 60px; */\n  justify-content: center;\n  flex-direction: column;\n"
    ]);
    LiquidityModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LiquidityModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 250px;\n  overflow: auto;\n  padding-right: 15px;\n"
    ]);
    LiquidityModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LiquidityModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 0;\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  cursor: ",
        ";\n"
    ]);
    LiquidityModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var LiquidityModal_ModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-246bd89c-0"
})(LiquidityModal_templateObject());
var LiquidityModal_ModalBody = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-246bd89c-1"
})(LiquidityModal_templateObject1());
var LiquidityModal_CoinScroll = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-246bd89c-2"
})(LiquidityModal_templateObject2());
var LiquidityModal_ListItem = (0,styled_components_browser_esm/* default */.ZP)(Row/* RowBetween */.m0).withConfig({
    componentId: "sc-246bd89c-3"
})(LiquidityModal_templateObject3(), function(param) {
    var disabled = param.disabled;
    return !disabled && "pointer";
});
function CurrencyRow(param) {
    var _currency = param.currency, currency = _currency === void 0 ? {
        token0: {
            name: "Binance",
            symbol: "BNB",
            address: "0x461d52769884ca6235b685ef2040f47d30c94eb5"
        },
        token1: {
            name: "Ethereum",
            symbol: "ETH",
            address: "0x922d641a426dcffaef11680e5358f34d97d112e1"
        }
    } : _currency, onSelect = param.onSelect, isSelected = param.isSelected;
    var ref, ref1;
    var account = useWeb3React().account;
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx(LiquidityModal_ListItem, {
        children: /*#__PURE__*/ _jsxs(Flex, {
            alignItems: "center",
            children: [
                /*#__PURE__*/ _jsx(DoubleCurrencyLogo, {
                    token0: currency.token0,
                    token1: currency.token1,
                    size: 30
                }),
                /*#__PURE__*/ _jsxs(Flex, {
                    style: {
                        marginLeft: "30px"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            children: currency === null || currency === void 0 ? void 0 : (ref = currency.token0) === null || ref === void 0 ? void 0 : ref.symbol
                        }),
                        /*#__PURE__*/ _jsxs(Text, {
                            color: "#92929B",
                            children: [
                                "/",
                                currency === null || currency === void 0 ? void 0 : (ref1 = currency.token1) === null || ref1 === void 0 ? void 0 : ref1.symbol
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var LiquidityModal = function(param) {
    var onDismiss = param.onDismiss, setCoinAddress = param.setCoinAddress, coinAddress = param.coinAddress;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var inputRef = (0,react.useRef)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var ref1 = (0,react.useState)([]), listData = ref1[0], setListData = ref1[1];
    var ref2 = (0,react.useState)([]), defaultListData = ref2[0], setDefalutListData = ref2[1];
    var ref3 = (0,react.useState)({}), pond = ref3[0], setPondData = ref3[1];
    var router = (0,next_router.useRouter)();
    // const parsedQueryChainId = Number(router.query.chainId)
    // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId')) || 17777
    // const { chainId } = useActiveWeb3React()
    var debouncedQuery = (0,useDebounce/* default */.Z)(searchQuery, 200);
    // const handleEnter = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    //   if (e.key === 'Enter') {
    //     console.log(e, 'eee')
    //   }
    // }, [])
    var fetch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, baseURL, chainid, ref1, data, code, formatData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
                        return [
                            4,
                            (0,service/* getVotePools */.Zc)({
                                baseURL: baseURL,
                                chainid: chainid
                            })
                        ];
                    case 1:
                        ref1 = _state.sent(), data = ref1.data, code = ref1.code;
                        formatData = [];
                        if (!code) {
                            formatData = data;
                        }
                        setDefalutListData(formatData);
                        setListData(formatData);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetch() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetCoin = function(item) {
        setCoinAddress(item);
        onDismiss();
    };
    (0,react.useEffect)(function() {
        // if (!account) return
        fetch();
    }, []);
    (0,react.useEffect)(function() {
        var copyListData = listData;
        console.log(listData, "listData");
        if (debouncedQuery) {
            copyListData = defaultListData.filter(function(v) {
                return (v === null || v === void 0 ? void 0 : v.symbol0.indexOf(debouncedQuery.toUpperCase())) > -1 || (v === null || v === void 0 ? void 0 : v.symbol1.indexOf(debouncedQuery.toUpperCase())) > -1;
            });
            console.log(copyListData, "copyListData");
            setListData(copyListData);
        } else {
            setListData(defaultListData);
        }
    }, [
        debouncedQuery
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalContainer */.F0, {
        $minWidth: isMobile ? "100%" : "418px",
        $minHeight: !isMobile ? "300px" : "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            style: {
                width: isMobile ? "100% " : "418px",
                height: !isMobile ? "auto" : "auto"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LiquidityModal_ModalHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                            style: {
                                fontSize: "20px",
                                fontWeight: "500"
                            },
                            children: t("noah403")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "text",
                            onClick: onDismiss,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                width: "24px",
                                color: "#000"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LiquidityModal_ModalBody, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                            style: {
                                width: "90%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                                style: {
                                    border: "1px solid #F6F6F6",
                                    paddingLeft: "10px",
                                    borderRadius: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/small-img/icon3.png",
                                        width: "20px",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        // 请输入流动池或者粘贴地址
                                        id: "token-search-input",
                                        placeholder: t("noah404"),
                                        scale: "lg",
                                        autoComplete: "off",
                                        value: searchQuery,
                                        ref: inputRef,
                                        onChange: function(event) {
                                            setSearchQuery(event.target.value);
                                        },
                                        // onKeyDown={handleEnter}
                                        style: {
                                            fontWeight: 400
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            style: {
                                background: "#FAFAFA",
                                width: "90%",
                                borderRadius: "6px"
                            },
                            padding: "15px",
                            my: "16px",
                            pr: "0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                    justifyContent: "space-between",
                                    mb: "10px",
                                    pr: "15px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LiquidityModal_CoinScroll, {
                                    children: listData.length > 0 ? listData === null || listData === void 0 ? void 0 : listData.map(function(v, i) {
                                        var ref, ref1, ref2, ref3;
                                        var symbolData = {
                                            token0: {
                                                address: v.contract0,
                                                symbol: v.symbol0
                                            },
                                            token1: {
                                                address: v.contract1,
                                                symbol: v.symbol1
                                            },
                                            price_direction: v.price_direction
                                        };
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LiquidityModal_ListItem, {
                                            onClick: function() {
                                                handleSetCoin(v);
                                            },
                                            children: (symbolData === null || symbolData === void 0 ? void 0 : symbolData.price_direction) == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                        token0: symbolData.token1,
                                                        token1: symbolData.token0,
                                                        size: 30
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                                        style: {
                                                            marginLeft: "30px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                                children: symbolData === null || symbolData === void 0 ? void 0 : (ref = symbolData.token1) === null || ref === void 0 ? void 0 : ref.symbol
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                                                color: "#92929B",
                                                                children: [
                                                                    "/",
                                                                    symbolData === null || symbolData === void 0 ? void 0 : (ref1 = symbolData.token0) === null || ref1 === void 0 ? void 0 : ref1.symbol
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                        token0: symbolData.token0,
                                                        token1: symbolData.token1,
                                                        size: 30
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                                        style: {
                                                            marginLeft: "30px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                                children: symbolData === null || symbolData === void 0 ? void 0 : (ref2 = symbolData.token0) === null || ref2 === void 0 ? void 0 : ref2.symbol
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                                                color: "#92929B",
                                                                children: [
                                                                    "/",
                                                                    symbolData === null || symbolData === void 0 ? void 0 : (ref3 = symbolData.token1) === null || ref3 === void 0 ? void 0 : ref3.symbol
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, i);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        style: {
                                            height: "240px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/small-img/noData.png",
                                                alt: "",
                                                width: "64px",
                                                style: {
                                                    marginBottom: "10px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                color: "textSubtle",
                                                textAlign: "center",
                                                children: t("noah116")
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            small: true,
                            mb: "50px",
                            textAlign: "left",
                            style: {
                                width: "90%"
                            },
                            color: "#92929B",
                            children: t("noah350")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_LiquidityModal = (LiquidityModal);

;// CONCATENATED MODULE: ./src/views/Bribery/index.tsx
/* eslint-disable */ 




function Bribery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  margin-bottom: 100px;\n  position: relative;\n  z-index: 10000;\n"
    ]);
    Bribery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Bribery_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: ",
        ";\n  .cont-cls {\n    width: 420px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    Bribery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Bribery_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    Bribery_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Bribery_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 30px;\n  padding: ",
        ";\n"
    ]);
    Bribery_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  border-radius: 20px;\n  padding: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 20px 0 20px 0;\n  width: ",
        ";\n  input::placeholder {\n    font-size: 20px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



























var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81b915d5-0"
})(Bribery_templateObject(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "100%" : "1100px";
});
var Cont = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81b915d5-1"
})(Bribery_templateObject1(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "center" : "space-between";
});
var BoxWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81b915d5-2"
})(Bribery_templateObject2());
var WrapCont = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81b915d5-3"
})(Bribery_templateObject3(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "100%" : "550px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "20px" : "20px 40px";
});
var InputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81b915d5-4"
})(_templateObject4(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "0 20px" : "0 20px";
});
var LabelRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81b915d5-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var width = param.width;
    return width || "100%";
});
function Bribery() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var ref9 = (0,wagmi_esm/* useSigner */.mx)(), signer = ref9.data;
    var isXxxxl = (0,useMatchBreakpoints/* default */.Z)().isXxxxl;
    var isMobile = !isXxxxl;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref10 = (0,react.useState)({}), coin = ref10[0], setCoin = ref10[1];
    var ref11 = (0,react.useState)({}), coinAddress = ref11[0], setCoinAddress = ref11[1];
    var ref12 = (0,react.useState)(), numInput = ref12[0], setNumInput = ref12[1];
    var isWrongNetwork = (0,useActiveChainId/* useActiveChainId */.gi)().isWrongNetwork;
    var debounceNumInput = (0,useDebounce/* default */.Z)(numInput, 200);
    var ref13 = (0,react.useState)({
        attemptingTxn: false,
        briberyErrorMessage: undefined,
        txHash: undefined
    }), ref14 = ref13[0], attemptingTxn = ref14.attemptingTxn, briberyErrorMessage = ref14.briberyErrorMessage, txHash = ref14.txHash, setBriberyState = ref13[1];
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var noahClass = null;
    var typedValueParsed = (0,lib_esm.parseUnits)(debounceNumInput || "0", (coin === null || coin === void 0 ? void 0 : (ref = coin.currency) === null || ref === void 0 ? void 0 : ref.decimals) || 18).toString();
    if (typedValueParsed !== "0") {
        noahClass = swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount((coin === null || coin === void 0 ? void 0 : coin.currency) || {}, swap_sdk_src/* JSBI.BigInt */.QA.BigInt(typedValueParsed));
    }
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.qL)(noahClass || {}, coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.bribe), 2), approval = ref15[0], approveCallback = ref15[1];
    var coinBalances = (0,wallet_hooks/* useTokenBalances */.Z)(account !== null && account !== void 0 ? account : undefined, [
        coin === null || coin === void 0 ? void 0 : coin.currency
    ])[coin === null || coin === void 0 ? void 0 : (ref1 = coin.currency) === null || ref1 === void 0 ? void 0 : ref1.address];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_LiquidityModal, {
        coinAddress: coinAddress,
        setCoinAddress: setCoinAddress
    }), true, true, "LiquidityModal"), 1), onPresentLiquidityModal = ref16[0];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_CoinModal, {
        coin: coin,
        setCoin: setCoin
    }), true, true, "CoinModal"), 1), onPresentCoinModal = ref17[0];
    // const BribeOtherContract = useOtherContract(coinAddress?.bribe || '', Bribe)
    // console.log(coin, 'coin')
    // console.log(coinAddress?.bribe, 'coinAddress?.bribe')
    // console.log(approval, 'approval')
    (0,react.useEffect)(function() {
        if (!(coin === null || coin === void 0 ? void 0 : coin.currency)) {
            setNumInput("");
            return;
        }
        // eslint-disable-next-line no-restricted-properties
        if ((coin === null || coin === void 0 ? void 0 : coin.currency) && Number(numInput) > Math.pow(10, 18)) {
            // eslint-disable-next-line no-restricted-properties
            setNumInput(Math.pow(10, 18).toString());
        }
    }, [
        debounceNumInput,
        coin,
        numInput
    ]);
    var handleCreate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, BribeOtherContract, estimate, method, args;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(coin === null || coin === void 0 ? void 0 : (ref = coin.currency) === null || ref === void 0 ? void 0 : ref.address) || !(coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.bribe)) return [
                            2
                        ];
                        if (approval === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED) {
                            approveCallback();
                            return [
                                2
                            ];
                        }
                        BribeOtherContract = null;
                        if (coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.bribe) {
                            BribeOtherContract = new contracts_lib_esm.Contract(coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.bribe, Bribe, signer);
                        }
                        estimate = null;
                        method = null;
                        args = null;
                        estimate = BribeOtherContract.estimateGas.notifyRewardAmount;
                        method = BribeOtherContract.notifyRewardAmount;
                        args = [
                            coin === null || coin === void 0 ? void 0 : coin.currency.address,
                            (0,lib_esm.parseUnits)(debounceNumInput || "0", 18).toString()
                        ];
                        setBriberyState({
                            attemptingTxn: true,
                            briberyErrorMessage: undefined,
                            txHash: undefined
                        });
                        onPresentResultModal();
                        return [
                            4,
                            estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).then(function(estimatedGasLimit) {
                                return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                    {
                                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                        // gasLimit: 400000,
                                        gasPrice: gasPrice
                                    }
                                ])).then(function(response) {
                                    var ref;
                                    console.log(response, "responseresponse");
                                    setBriberyState({
                                        attemptingTxn: false,
                                        briberyErrorMessage: undefined,
                                        txHash: response.hash
                                    });
                                    addTransaction(response, {
                                        summary: "Bribery",
                                        translatableSummary: {
                                            text: t("Create a %num% %coin% bribe", {
                                                num: debounceNumInput,
                                                coin: coin === null || coin === void 0 ? void 0 : (ref = coin.currency) === null || ref === void 0 ? void 0 : ref.symbol
                                            }),
                                            data: {}
                                        },
                                        type: "bribery"
                                    });
                                // setTimeout(() => {
                                //   setNumInput('')
                                // }, 4000)
                                });
                            }).catch(function(err) {
                                console.log(err, "errrrrr");
                                if (err && err.code !== 4001) {
                                    console.error("Bribery failed", err);
                                    setBriberyState({
                                        attemptingTxn: false,
                                        briberyErrorMessage: err.message,
                                        txHash: undefined
                                    });
                                }
                                setBriberyState({
                                    attemptingTxn: false,
                                    briberyErrorMessage: err && err.code !== 4001 ? t("Bribery failed: %message%", {
                                        message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                    }) : undefined,
                                    txHash: undefined
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCreate() {
            return _ref.apply(this, arguments);
        };
    }();
    var buttonText = function() {
        var ref;
        // 请选择流动池
        if (!(coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.bribe)) {
            return t("noah433");
        }
        // 请选择币种
        if (!(coin === null || coin === void 0 ? void 0 : (ref = coin.currency) === null || ref === void 0 ? void 0 : ref.address)) {
            return t("noah434");
        }
        // console.log(Number(debounceNumInput), '111')
        // console.log(Number(coin?.toSignificant()), '222')
        // 余额不足
        if (Number(debounceNumInput) > Number(coinBalances === null || coinBalances === void 0 ? void 0 : coinBalances.toSignificant())) {
            var ref1;
            return t("Insufficient %coin% balance", {
                coin: coin === null || coin === void 0 ? void 0 : (ref1 = coin.currency) === null || ref1 === void 0 ? void 0 : ref1.symbol
            });
        }
        // 授权
        if (approval === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED) {
            var ref2;
            return "".concat(t("noah410"), " ").concat(coin === null || coin === void 0 ? void 0 : (ref2 = coin.currency) === null || ref2 === void 0 ? void 0 : ref2.symbol);
        }
        if (!Number(debounceNumInput)) {
            // 请输入数量
            return t("noah303");
        }
        return t("noah78");
    };
    var pendingText = t("Create a %num% %coin% bribe", {
        num: debounceNumInput,
        coin: coin === null || coin === void 0 ? void 0 : (ref2 = coin.currency) === null || ref2 === void 0 ? void 0 : ref2.symbol
    });
    var clearInput = function() {
        setNumInput("");
    };
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ResultModal/* default */.ZP, {
        pendingText: pendingText,
        hash: txHash,
        attemptingTxn: attemptingTxn,
        errorMessage: briberyErrorMessage,
        // 创建成功
        successText: t("noah381"),
        // 创建失败
        failText: t("noah382"),
        clearInput: clearInput,
        isSuccess: function() {
            console.log("successGetdata1111111111111");
        // getData()
        // setTimeout(() => {
        //   setNumInput('')
        // }, 5000);
        }
    }), false, true, "ResultModal"), 1), onPresentResultModal = ref18[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        footer: false,
        style: {
            paddingTop: !isMobile ? "50px" : ""
        },
        isMobile: isMobile,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
            isMobile: isMobile,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                    fontSize: isMobile ? "20px" : "20px",
                    fontWeight: "600",
                    mb: "5px",
                    children: t("noah346")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                    fontSize: isMobile ? "14px" : "14px",
                    mb: "50px",
                    children: t("noah347")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Cont, {
                    isMobile: isMobile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapCont, {
                            style: {
                                padding: isMobile ? "16px" : "20px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWrap, {
                                    isMobile: isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelRow, {
                                                width: "50%",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                    children: t("noah286")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelRow, {
                                                width: "50%",
                                                style: {
                                                    flexDirection: "row-reverse",
                                                    cursor: "pointer"
                                                },
                                                onClick: function() {
                                                    onPresentLiquidityModal();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                                    alignItems: "center",
                                                    children: [
                                                        (coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.bribe) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                                            alignItems: "center",
                                                            children: [
                                                                (coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.price_direction) == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                                    token0: {
                                                                        address: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.contract1,
                                                                        symbol: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol1
                                                                    },
                                                                    token1: {
                                                                        address: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.contract0,
                                                                        symbol: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol0
                                                                    },
                                                                    size: 30
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                                    token0: {
                                                                        address: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.contract0,
                                                                        symbol: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol0
                                                                    },
                                                                    token1: {
                                                                        address: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.contract1,
                                                                        symbol: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol1
                                                                    },
                                                                    size: 30
                                                                }),
                                                                (coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.price_direction) == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                                                    style: {
                                                                        marginLeft: "30px"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                                            children: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol1
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                                                            color: "#92929B",
                                                                            children: [
                                                                                "/",
                                                                                coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol0
                                                                            ]
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                                                    style: {
                                                                        marginLeft: "30px"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                                            children: coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol0
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                                                            color: "#92929B",
                                                                            children: [
                                                                                "/",
                                                                                coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol1
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : // 选择流动池
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                            fontSize: isMobile ? "15px" : "15px",
                                                            children: t("noah435")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrap, {
                                    style: {
                                        background: "#FAFAFA",
                                        marginTop: "15px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                            justifyContent: "space-between",
                                            style: {
                                                padding: "20px 0 0",
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                setNumInput((coinBalances === null || coinBalances === void 0 ? void 0 : coinBalances.toSignificant()) || "0");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                    small: true,
                                                    children: t("noah348")
                                                }),
                                                (coin === null || coin === void 0 ? void 0 : (ref3 = coin.currency) === null || ref3 === void 0 ? void 0 : ref3.address) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                                    color: "#85868A",
                                                    small: true,
                                                    children: [
                                                        t("noah312"),
                                                        "：",
                                                        (coinBalances === null || coinBalances === void 0 ? void 0 : coinBalances.toSignificant()) || "-"
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelRow, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericalInput/* default */.Z, {
                                                        align: "left",
                                                        fontSize: isMobile ? "20px" : "20px",
                                                        // placeholder={t('noah265')}
                                                        value: numInput,
                                                        onUserInput: function(val) {
                                                            setNumInput(val);
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelRow, {
                                                    width: isMobile ? "90%" : "55%",
                                                    style: {
                                                        flexDirection: "row-reverse",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        onPresentCoinModal();
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {}),
                                                        (coin === null || coin === void 0 ? void 0 : (ref4 = coin.currency) === null || ref4 === void 0 ? void 0 : ref4.address) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                                            alignItems: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    mr: "5px",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                                        token0: coin === null || coin === void 0 ? void 0 : coin.currency,
                                                                        size: 30
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                                    fontSize: isMobile ? "16px" : "18px",
                                                                    color: "#333",
                                                                    children: coin === null || coin === void 0 ? void 0 : (ref5 = coin.currency) === null || ref5 === void 0 ? void 0 : ref5.symbol
                                                                })
                                                            ]
                                                        }) : // 選擇幣種
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                            fontSize: isMobile ? "15px" : "15px",
                                                            children: t("noah142")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                numInput && (coin === null || coin === void 0 ? void 0 : (ref6 = coin.currency) === null || ref6 === void 0 ? void 0 : ref6.address) && (coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.bribe) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    fontSize: "13px",
                                    mt: "25px",
                                    textAlign: "center",
                                    color: "#14162A",
                                    children: t("You are creating a %num% %coin% bribe to incentivize voters to vote for %pool% pools.", {
                                        num: (numInput * 0.9).toFixed(1),
                                        coin: coin === null || coin === void 0 ? void 0 : (ref7 = coin.currency) === null || ref7 === void 0 ? void 0 : ref7.symbol,
                                        pool: "".concat(coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol0, "/").concat(coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.symbol1)
                                    })
                                }),
                                !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                                    style: {
                                        width: "100%",
                                        marginTop: "25px"
                                    },
                                    children: t("noah346")
                                }) : isWrongNetwork ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                                    style: {
                                        marginTop: "25px"
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    width: "100%",
                                    mb: "0px",
                                    mt: "25px",
                                    onClick: function() {
                                        handleCreate();
                                    },
                                    disabled: !(coin === null || coin === void 0 ? void 0 : (ref8 = coin.currency) === null || ref8 === void 0 ? void 0 : ref8.address) || !(coinAddress === null || coinAddress === void 0 ? void 0 : coinAddress.bribe) || !Number(debounceNumInput) || approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING || Number(debounceNumInput) > Number(coinBalances === null || coinBalances === void 0 ? void 0 : coinBalances.toSignificant()),
                                    children: buttonText()
                                })
                            ]
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cont-cls",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/small-img/create.png",
                                alt: ""
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/incentive/index.tsx


var BriberyPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bribery, {});
};
BriberyPage.Layout = BriberyPage;
// BriberyPage.mp = false
/* harmony default export */ var incentive = (BriberyPage);


/***/ }),

/***/ 71900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K5": function() { return /* binding */ useCurrencyBalances; },
/* harmony export */   "Z": function() { return /* binding */ useTokenBalances; },
/* harmony export */   "_h": function() { return /* binding */ useCurrencyBalance; },
/* harmony export */   "mM": function() { return /* binding */ useTokenBalance; },
/* harmony export */   "uD": function() { return /* binding */ useAllTokenBalances; },
/* harmony export */   "v2": function() { return /* binding */ useTokenBalancesWithLoadingIndicator; }
/* harmony export */ });
/* unused harmony export useNativeBalances */
/* harmony import */ var _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79331);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _noahswap_wagmi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67539);
/* harmony import */ var config_abi_erc20__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85169);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61905);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93293);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70176);
/* harmony import */ var hooks_useCommonTokens__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67673);
/* harmony import */ var _multicall_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91001);
/* eslint-disable */ 









/**
 * Returns a map of the given addresses to their eventually consistent EOS balances.
 */ function useNativeBalances(uncheckedAddresses) {
    var native = (0,hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    // console.log('🍉native', native)
    var multicallContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_4__/* .useMulticallContract */ .gq)();
    // console.log('🍉multicallContract', multicallContract)
    var addresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return uncheckedAddresses ? lodash_orderBy__WEBPACK_IMPORTED_MODULE_6___default()(uncheckedAddresses.map(utils__WEBPACK_IMPORTED_MODULE_5__/* .isAddress */ .UJ).filter(function(a) {
            return a !== false;
        })) : [];
    }, [
        uncheckedAddresses
    ]);
    // console.log('🍉addresses', addresses)
    var results = (0,_multicall_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useSingleContractMultipleData */ .es)(multicallContract, "getEthBalance", (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return addresses.map(function(address) {
            return [
                address
            ];
        });
    }, [
        addresses
    ]));
    // console.log('🍉results', results)
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return addresses.reduce(function(memo, address, i) {
            var ref, ref1;
            var value = results === null || results === void 0 ? void 0 : (ref = results[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
            if (value) memo[address] = _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(native, _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(value.toString()));
            return memo;
        }, {});
    }, [
        addresses,
        results,
        native
    ]);
}
/**
 * Returns a map of token addresses to their eventually consistent token balances for a single account.
 */ function useTokenBalancesWithLoadingIndicator(address, tokens) {
    var ref;
    var validatedTokens = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref = tokens === null || tokens === void 0 ? void 0 : tokens.filter(function(t) {
            return (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .isAddress */ .UJ)(t === null || t === void 0 ? void 0 : t.address) !== false;
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        tokens
    ]);
    var validatedTokenAddresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return validatedTokens.map(function(vt) {
            return vt.address;
        });
    }, [
        validatedTokens
    ]);
    var balances = (0,_multicall_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useMultipleContractSingleData */ ._Y)(validatedTokenAddresses, config_abi_erc20__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, "balanceOf", (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return [
            address
        ];
    }, [
        address
    ]));
    var anyLoading = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return balances.some(function(callState) {
            return callState.loading;
        });
    }, [
        balances
    ]);
    return [
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
            return address && validatedTokens.length > 0 ? validatedTokens.reduce(function(memo, token, i) {
                var ref, ref1;
                var value = balances === null || balances === void 0 ? void 0 : (ref = balances[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
                var amount = value ? _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(value.toString()) : undefined;
                if (amount) {
                    memo[token.address] = _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(token, amount);
                }
                return memo;
            }, {}) : {};
        }, [
            address,
            validatedTokens,
            balances
        ]),
        anyLoading, 
    ];
}
function useTokenBalances(address, // tokens?: (Token | undefined)[],
tokens) {
    return useTokenBalancesWithLoadingIndicator(address, tokens)[0];
}
// get the balance for a single token/account combo
function useTokenBalance(account, token) {
    var tokenBalances = useTokenBalances(account, [
        token
    ]);
    if (!token) return undefined;
    return tokenBalances[token.address];
}
function useCurrencyBalances(account, currencies) {
    var ref;
    var tokens = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref = currencies === null || currencies === void 0 ? void 0 : currencies.filter(function(currency) {
            return currency === null || currency === void 0 ? void 0 : currency.isToken;
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        currencies
    ]);
    // console.log('account---', account)
    // console.log('tokens---', tokens)
    var tokenBalances = useTokenBalances(account, tokens);
    var ref1;
    // console.log('tokenBalances---', tokenBalances)
    var containsNative = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref1 = currencies === null || currencies === void 0 ? void 0 : currencies.some(function(currency) {
            return currency === null || currency === void 0 ? void 0 : currency.isNative;
        })) !== null && ref1 !== void 0 ? ref1 : false;
    }, [
        currencies
    ]);
    // console.log('containsNative---', containsNative)
    var uncheckedAddresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return containsNative ? [
            account
        ] : [];
    }, [
        containsNative,
        account
    ]);
    // console.log('uncheckedAddresses---', uncheckedAddresses)
    var nativeBalance = useNativeBalances(uncheckedAddresses);
    var ref2;
    // console.log('nativeBalance---', nativeBalance)
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref2 = currencies === null || currencies === void 0 ? void 0 : currencies.map(function(currency) {
            if (!account || !currency) return undefined;
            if (currency === null || currency === void 0 ? void 0 : currency.isToken) return tokenBalances[currency.address];
            if (currency === null || currency === void 0 ? void 0 : currency.isNative) return nativeBalance[account];
            return undefined;
        })) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        account,
        currencies,
        nativeBalance,
        tokenBalances
    ]);
}
function useCurrencyBalance(account, currency) {
    return useCurrencyBalances(account, [
        currency
    ])[0];
}
// mimics useAllBalances
function useAllTokenBalances() {
    var account = (0,_noahswap_wagmi__WEBPACK_IMPORTED_MODULE_2__/* .useWeb3React */ .Ge)().account;
    // const allTokens = useAllTokens()
    var allTokens = (0,hooks_useCommonTokens__WEBPACK_IMPORTED_MODULE_8__/* .useCommonTokens */ .k)();
    // console.log('wallet/hooks.ts', '执行了getCoinList')
    var allTokensArray = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Object.values(allTokens !== null && allTokens !== void 0 ? allTokens : {});
    }, [
        allTokens
    ]);
    var balances = useTokenBalances(account !== null && account !== void 0 ? account : undefined, allTokensArray);
    return balances !== null && balances !== void 0 ? balances : {};
}


/***/ }),

/***/ 42658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P4": function() { return /* binding */ basisPointsToPercent; },
  "uc": function() { return /* binding */ calculateSlippageAmount; },
  "b5": function() { return /* binding */ computeSlippageAdjustedAmounts; },
  "U7": function() { return /* binding */ computeTradePriceBreakdown; },
  "Ti": function() { return /* binding */ useRouterContract; },
  "oX": function() { return /* binding */ warningSeverity; }
});

// UNUSED EXPORTS: formatExecutionPrice

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var src = __webpack_require__(79331);
;// CONCATENATED MODULE: ./src/config/abi/INoahRouter02.json
var INoahRouter02_namespaceObject = JSON.parse('[{"inputs":[{"internalType":"address","name":"_factory","type":"address"},{"internalType":"address","name":"_WETH","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"WETH","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"amountADesired","type":"uint256"},{"internalType":"uint256","name":"amountBDesired","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amountTokenDesired","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountIn","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountOut","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsIn","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsOut","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"reserveA","type":"uint256"},{"internalType":"uint256","name":"reserveB","type":"uint256"}],"name":"quote","outputs":[{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETHSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermit","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermitSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityWithPermit","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapETHForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETHSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}]');
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(62349);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(61905);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
;// CONCATENATED MODULE: ./src/utils/exchange.ts







// converts a basis points value to a sdk percent
function basisPointsToPercent(num) {
    return new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(num), exchange/* BIPS_BASE */.PM);
}
function calculateSlippageAmount(value, slippage) {
    if (slippage < 0 || slippage > 10000) {
        throw Error("Unexpected slippage value: ".concat(slippage));
    }
    return [
        src/* JSBI.divide */.QA.divide(src/* JSBI.multiply */.QA.multiply(value.quotient, src/* JSBI.BigInt */.QA.BigInt(10000 - slippage)), exchange/* BIPS_BASE */.PM),
        src/* JSBI.divide */.QA.divide(src/* JSBI.multiply */.QA.multiply(value.quotient, src/* JSBI.BigInt */.QA.BigInt(10000 + slippage)), exchange/* BIPS_BASE */.PM), 
    ];
}
function useRouterContract() {
    var chainId = (0,useActiveChainId/* useActiveChainId */.gi)().chainId;
    return (0,useContract/* useContract */.cq)(exchange/* ROUTER_ADDRESS */.bR[chainId], INoahRouter02_namespaceObject, true);
}
// computes price breakdown for the trade
function computeTradePriceBreakdown(trade) {
    // for each hop in our trade, take away the x*y=k price impact from 0.3% fees
    // e.g. for 3 tokens/2 hops: 1 - ((1 - .03) * (1-.03))
    var realizedLPFee = !trade ? undefined : exchange/* ONE_HUNDRED_PERCENT.subtract */.yC.subtract(trade.route.pairs.reduce(function(currentFee) {
        return currentFee.multiply(exchange/* INPUT_FRACTION_AFTER_FEE */.Zw);
    }, exchange/* ONE_HUNDRED_PERCENT */.yC));
    // remove lp fees from price impact
    var priceImpactWithoutFeeFraction = trade && realizedLPFee ? trade.priceImpact.subtract(realizedLPFee) : undefined;
    // the x*y=k impact
    var priceImpactWithoutFeePercent = priceImpactWithoutFeeFraction ? new src/* Percent */.gG(priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.numerator, priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.denominator) : undefined;
    // the amount of the input that accrues to LPs
    var realizedLPFeeAmount = realizedLPFee && trade && src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(trade.inputAmount.currency, realizedLPFee.multiply(trade.inputAmount.quotient).quotient);
    return {
        priceImpactWithoutFee: priceImpactWithoutFeePercent,
        realizedLPFee: realizedLPFeeAmount
    };
}
// computes the minimum amount out and maximum amount in for a trade given a user specified allowed slippage in bips
function computeSlippageAdjustedAmounts(trade, allowedSlippage) {
    var pct = basisPointsToPercent(allowedSlippage);
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, trade === null || trade === void 0 ? void 0 : trade.maximumAmountIn(pct)), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, trade === null || trade === void 0 ? void 0 : trade.minimumAmountOut(pct)), _obj;
}
function warningSeverity(priceImpact) {
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* BLOCKED_PRICE_IMPACT_NON_EXPERT */.lN))) return 4;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_HIGH */.Uf))) return 3;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_MEDIUM */.p9))) return 2;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_LOW */.Bz))) return 1;
    return 0;
}
function formatExecutionPrice(trade, inverted) {
    if (!trade) {
        return "";
    }
    return inverted ? "".concat(trade.executionPrice.invert().toSignificant(6), " ").concat(trade.inputAmount.currency.symbol, " / ").concat(trade.outputAmount.currency.symbol) : "".concat(trade.executionPrice.toSignificant(6), " ").concat(trade.outputAmount.currency.symbol, " / ").concat(trade.inputAmount.currency.symbol);
}


/***/ }),

/***/ 90570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uriToHttp; }
/* harmony export */ });
/* eslint-disable no-case-declarations */ /**
 * Given a URI that may be ipfs, ipns, http, or https protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */ function uriToHttp(uri) {
    var protocol = uri.split(":")[0].toLowerCase();
    switch(protocol){
        case "https":
            return [
                uri
            ];
        case "http":
            return [
                "https".concat(uri.substring(4)),
                uri
            ];
        case "ipfs":
            var ref;
            var hash = (ref = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || ref === void 0 ? void 0 : ref[2];
            return [
                "https://cloudflare-ipfs.com/ipfs/".concat(hash, "/"),
                "https://ipfs.io/ipfs/".concat(hash, "/")
            ];
        case "ipns":
            var ref1;
            var name = (ref1 = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || ref1 === void 0 ? void 0 : ref1[2];
            return [
                "https://cloudflare-ipfs.com/ipns/".concat(name, "/"),
                "https://ipfs.io/ipns/".concat(name, "/")
            ];
        default:
            return [];
    }
}


/***/ }),

/***/ 60764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ CurrencyLogo; },
  "g": function() { return /* binding */ DoubleCurrencyLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/LogoLoader.tsx





var BAD_SRCS = [];
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback to HelpIcon
 */ var LogoLoader = function(_param) {
    var src = _param.src, alt = _param.alt, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt"
    ]);
    var ref = (0,react.useState)(0), refresh = ref[1];
    var srcFailedLoading = BAD_SRCS.includes(src);
    if (src && !srcFailedLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS.push(src);
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        src: "/images/small-img/default-icon.png",
        alt: ""
    }));
// return <HelpIcon {...rest} />
};
/* harmony default export */ var CurrencyLogo_LogoLoader = (LogoLoader);

;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx
/* eslint-disable */ 


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  /* box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075); */\n  background-color: ",
        ";\n  color: ",
        ";\n  margin-right: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 32px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(CurrencyLogo_LogoLoader).withConfig({
    componentId: "sc-1182136a-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg && "-6px";
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg ? "4" : "3";
});
var CurrencyLogo = function(_param) {
    var address = _param.address, symbol = _param.symbol, _size = _param.size, size = _size === void 0 ? "24px" : _size, _firstimg = _param.firstimg, firstimg = _firstimg === void 0 ? "false" : _firstimg, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "address",
        "symbol",
        "size",
        "firstimg"
    ]);
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var src = (0,react.useMemo)(function() {
        // const checksummedAddress = isAddress(address)
        if (address && symbol) {
            // return `https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/${checksummedAddress}/logo.png`
            // return `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/${chainId}-${address.toLowerCase()}-${symbol.toLowerCase()}.png`
            return "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/".concat(chainId, "-").concat(address.toLowerCase(), "-").concat(symbol.toLowerCase(), ".png");
        }
        return null;
    }, [
        address,
        symbol,
        chainId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, (0,_object_spread/* default */.Z)({
        size: size,
        src: src,
        alt: "token logo",
        firstimg: firstimg
    }, rest));
};
var DoubleCurrencyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1182136a-1"
})(_templateObject1());
var DoubleCurrencyLogo = function(param) {
    var token0 = param.token0, token1 = param.token1, _size = param.size, size = _size === void 0 ? 16 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoubleCurrencyWrapper, {
        children: [
            (token0 === null || token0 === void 0 ? void 0 : token0.address) && (token0 === null || token0 === void 0 ? void 0 : token0.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token0 === null || token0 === void 0 ? void 0 : token0.address,
                symbol: token0 === null || token0 === void 0 ? void 0 : token0.symbol,
                size: "".concat(size.toString(), "px"),
                firstimg: "true"
            }),
            (token1 === null || token1 === void 0 ? void 0 : token1.address) && (token1 === null || token1 === void 0 ? void 0 : token1.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token1 === null || token1 === void 0 ? void 0 : token1.address,
                symbol: token1 === null || token1 === void 0 ? void 0 : token1.symbol,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
};


/***/ }),

/***/ 33109:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"inputs":[{"internalType":"address","name":"_voter","type":"address"},{"internalType":"bool","name":"_isForPair","type":"bool"},{"internalType":"address[]","name":"_allowedRewardTokens","type":"address[]"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"address[]","name":"tokens","type":"address[]"},{"indexed":false,"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"name":"ClaimFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"reward","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"ClaimRewards","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"reward","type":"address"},{"indexed":false,"internalType":"uint256","name":"epoch","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"fee","type":"uint256"}],"name":"NotifyReward","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Voter","type":"event"},{"inputs":[],"name":"_ve","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"account","type":"address"}],"name":"_voted","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address[]","name":"tokens","type":"address[]"}],"name":"_withdrawBribe","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"batchEarned","outputs":[{"internalType":"address[]","name":"tokens","type":"address[]"},{"internalType":"uint256[]","name":"claimables","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"bribeStart","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"checkpoints","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"claimFees","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"account","type":"address"}],"name":"earned","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"_nCheckPoints","type":"uint256"}],"name":"getCheckpoint","outputs":[{"components":[{"internalType":"uint256","name":"timestamp","type":"uint256"},{"internalType":"uint256","name":"balanceOf","type":"uint256"}],"internalType":"struct Bribe.Checkpoint","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"getPriorBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"getPriorBalanceIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"getPriorSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"getPriorSupplyIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"address[]","name":"tokens","type":"address[]"}],"name":"getReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_nCheckPoints","type":"uint256"}],"name":"getSupplyCheckpoint","outputs":[{"components":[{"internalType":"uint256","name":"timestamp","type":"uint256"},{"internalType":"uint256","name":"supply","type":"uint256"}],"internalType":"struct Bribe.SupplyCheckpoint","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isForPair","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"isReward","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"lastEarn","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"lastTimeRewardApplicable","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lastWithdrawEpoch","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"left","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"notifyRewardAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"numCheckpoints","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"periodFinish","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"rewards","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"rewardsListLength","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"supplyCheckpoints","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"supplyNumCheckpoints","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"i","type":"uint256"},{"internalType":"address","name":"oldToken","type":"address"},{"internalType":"address","name":"newToken","type":"address"}],"name":"swapOutRewardToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenRewardsPerEpoch","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"voter","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}]');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2632,9774,2888,179], function() { return __webpack_exec__(479); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);